import { Field, Image, ImageField, Link, LinkField, RichText, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import styles from './HeroBlock.module.css';

type HeroBlockProps = ComponentProps & {
	fields: {
		Description: Field<string>;
		Image: ImageField;
		Link: LinkField;
		Title: Field<string>;
	};
};

export default withDatasourceCheck()<HeroBlockProps>(HeroBlock);

function HeroBlock(props: HeroBlockProps): JSX.Element {
	const isEditing = IsSitecoreEditing();

	return (
		<section className={styles.section}>
			<div className={`${styles.row} maxWidth`}>
				<div className={styles.col}>
					<Text tag="h1" field={props.fields.Title} className={styles.title} />

					<RichText tag="div" field={props.fields.Description} className={styles.description} />

					{(props.fields.Link?.value?.href || isEditing) && (
						<Link field={props.fields.Link} className={`${styles.button} button pinkDark`} />
					)}
				</div>

				<div className={styles.col}>
					<EditorHelp text="Image maxWidth 800px" />
					<Image className={styles.image} media={props.fields.Image} loading="lazy" height={600} width={800} />
				</div>
			</div>
		</section>
	);
}
